import * as Sentry from "@sentry/react";

import protectedAxios from "../axios";
import { API_URL } from "../constants";

export const getUserConversationFromId = async (
  conversationId,
  successCallBack = () => {},
  failureCallBack = () => {}
) => {
  try {
    const { data } = await protectedAxios.get(
      `${API_URL}/v1/chat/conversation.getOne/${conversationId}`
    );

    successCallBack(data);
    return data;
  } catch (error) {
    // Don't report 404 to Sentry - conversation may be deleted or user unauthorized
    if (error?.status !== 404) {
      Sentry.captureException(error);
    }
    failureCallBack(error);
    throw error;
  }
};

export const createGroupConversation = async (payload) => {
  try {
    const { data } = await protectedAxios.post(
      `${API_URL}/v1/chat/conversation.create.group`,
      payload
    );

    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const createSpaceConversation = async (payload) => {
  try {
    const { data } = await protectedAxios.post(
      `${API_URL}/v1/chat/conversation.space.create`,
      payload
    );

    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const getConversationParticipantIds = async (conversationId) => {
  try {
    const { data } = await protectedAxios.get(
      `${API_URL}/v1/chat/conversation.participantsIds/${conversationId}`
    );
    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const updateConversation = async (payload) => {
  try {
    const { data } = await protectedAxios.patch(
      `${API_URL}/v1/chat/conversation.participant`,
      payload
    );
    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const updateGroupInfo = async ({ id, ...payload }) => {
  try {
    const { data } = await protectedAxios.patch(
      `${API_URL}/v1/chat/conversation.group/${id}`,
      payload
    );
    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const removeFromConversation = async (conversationId) => {
  try {
    const { data } = await protectedAxios.delete(
      `${API_URL}/v1/chat/conversation.participant/${conversationId}`
    );
    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const kickUsers = async ({ conversationId, participantIds }) => {
  try {
    const { data } = await protectedAxios.post(
      `${API_URL}/v1/chat/conversation.participants/kick/${conversationId}`,
      {
        participantIds,
      }
    );
    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};
